import axios from 'axios'
import { message } from 'ant-design-vue'
import router from '@/router'

// Only an expired/invalid authentication (401) ends a session. A denied
// operation (403) must leave the operator's login and unsaved form intact.
function exitExpiredLogin() {
    localStorage.removeItem('token')
    if (router.currentRoute.path === '/login') {
        return
    }
    router.replace({ path: '/login', query: { redirect: router.currentRoute.fullPath } }).catch(() => {})
}

// 创建 axios 实例
// baseURL：开发环境走 /api（vue.config.js 代理到本地 3000）；
// 生产构建通过 .env.production 的 VUE_APP_API_BASE_URL 覆盖为线上域名。
const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
    timeout: 6000
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }
        config.headers['Accept-Language'] = localStorage.getItem('jiangk-admin-locale') || 'zh-Hans'
        return config
    },
    error => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        if (response.config && response.config.responseType === 'blob') {
            return response.data
        }
        const res = response.data
        // 约定 code 200 为成功
        if (!res || res.code !== 200) {
            const error = new Error((res && res.msg) || 'Invalid server response')
            // Preserve structured details for field/conflict/permission handling.
            // response.status remains the actual HTTP status, not the business code.
            error.businessCode = res && res.code
            error.data = res && res.data
            error.response = response
            error.config = response.config
            error.isBusinessError = true
            if (Number(error.businessCode) === 401) exitExpiredLogin()
            else if (!(response.config && response.config.silentError)) message.error(error.message)
            return Promise.reject(error)
        } else {
            return res
        }
    },
    error => {
        const status = error.response && error.response.status
        if (error.response && error.response.data) {
            const body = error.response.data
            error.businessCode = body.code
            error.data = body.data
            if (typeof body.msg === 'string' && body.msg.trim()) error.message = body.msg
        }
        if (status === 401) {
            exitExpiredLogin()
        } else if (!(error.config && error.config.silentError)) {
            message.error(error.message)
        }
        return Promise.reject(error)
    }
)

export default service
